import React from "react";
import ordersIcon from "../../../../assets/Icons/dashboard/orders.svg";

const CARDS = [
  {
    key: "new",
    label: "New Orders",
    iconBg: "bg-[#EFF6FF]",
    ring: "ring-blue-100/80",
  },
  {
    key: "processing",
    label: "Processing",
    iconBg: "bg-[#FFF6ED]",
    ring: "ring-orange-100/80",
  },
  {
    key: "out_delivery",
    label: "Out for Delivery",
    iconBg: "bg-[#F5F3FF]",
    ring: "ring-violet-100/80",
  },
  {
    key: "delivered",
    label: "Delivered",
    iconBg: "bg-[#ECFDF3]",
    ring: "ring-emerald-100/80",
  },
];

export function OrdersStats({ counts }) {
  return (
    <div className="mb-8 grid grid-cols-2 gap-0 sm:grid-cols-2 xl:grid-cols-4">
      {CARDS.map((card) => (
        <div
          key={card.key}
          className="flex items-center justify-between rounded-none md:rounded-[14px] border border-[#EFEFEF] bg-white px-5 py-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
        >
          <div>
            <p className="my-0 text-[13px] font-medium text-[#6B7280]">
              {card.label}
            </p>
            <p className="my-0 mt-2 text-[22px] font-semibold tabular-nums tracking-tight text-[#151515]">
              {counts[card.key] ?? 0}
            </p>
          </div>
          <div
            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ring-1 ${card.ring} ${card.iconBg}`}
          >
            <img src={ordersIcon} alt="" className="h-7 w-7 opacity-90" />
          </div>
        </div>
      ))}
    </div>
  );
}
